import React from 'react';
import KeyboardShortcutItem from './KeyboardShortcutItem';
import { VerticalShortcutsProps } from './ShortcutHelper.props';

const VerticalShortcuts: React.FC<VerticalShortcutsProps> = ({ browserOS, shortcuts }) => (
  <>
    {shortcuts.map(({ action, combination }) => (
      <KeyboardShortcutItem action={action} combination={combination[browserOS ?? 'windows']} key={action} />
    ))}
  </>
);

export default VerticalShortcuts;
